export default __webpack_public_path__ + "static/media/site-logo.459a992a.svg";